import mcImage from '@shared/static/nodes/mc.svg';
import ngfwImage from '@shared/static/nodes/ngfw.svg';
import swgImage from '@shared/static/nodes/swg.svg';
import dcfwImage from '@shared/static/nodes/dcfw.svg';
import wafImage from '@shared/static/nodes/waf.svg';
import siemImage from '@shared/static/nodes/siem.svg';
import pcImage from '@shared/static/nodes/pc.svg';
import astraLinuxImage from '@shared/static/nodes/astralinux.svg';
import redosImage from '@shared/static/nodes/redos.svg';
import kaliLinuxImage from '@shared/static/nodes/kalilinux.svg';
import adImage from '@shared/static/nodes/ad.svg';
import techTourAdImage from '@shared/static/nodes/tech-tour-ad.svg';
import wecImage from '@shared/static/nodes/wec.svg';
import loganImage from '@shared/static/nodes/logan.svg';
import pppoeImage from '@shared/static/nodes/server.svg';
import windowsImage from '@shared/static/nodes/windows.svg';
import encryptorImage from '@shared/static/nodes/encryptor.svg';
import ftpImage from '@shared/static/nodes/ftp.svg';
import telemetryImage from '@shared/static/nodes/telemetry.svg';
import smtpImage from '@shared/static/nodes/smtp.svg';
import icapImage from '@shared/static/nodes/icap.svg';
import radiusImage from '@shared/static/nodes/radius.svg';
import tacacsImage from '@shared/static/nodes/tacacs+.svg';
import webServerImage from '@shared/static/nodes/web-server.svg';
import vulnerableappImage from '@shared/static/nodes/vulnerable-app.svg';
import ciscoImage from '@shared/static/nodes/cisco.svg';
import testagentImage from '@shared/static/nodes/testagent.svg';
import ptmgmtImage from '@shared/static/nodes/ptmgmt.svg';
import ptngfwImage from '@shared/static/nodes/ptngfw.svg';
import wwwImage from '@shared/static/nodes/www.svg';
import wwwImage1 from '@shared/static/nodes/www1.svg';
import wwwImage2 from '@shared/static/nodes/www2.svg';
import collectorImage from '@shared/static/nodes/collector.svg';
import mgtaImage from '@shared/static/nodes/mgt-a.svg';
import mgtaIntroImage from '@shared/static/nodes/mgt-a-intro.svg';
import ispIntroImage from '@shared/static/nodes/isp-intro.svg';
import ispImage1 from '@shared/static/nodes/isp1.svg';
import ispImage2 from '@shared/static/nodes/isp2.svg';
import internetImage from '@shared/static/nodes/internet.svg';
import clialxImage from '@shared/static/nodes/cli-a-lx.svg';
import mikrotikImage from '@shared/static/nodes/mikrotik.svg';

export const MAP_NODE_TO_IMAGE = {
    mc: mcImage,
    ngfw: ngfwImage,
    swg: swgImage,
    dcfw: dcfwImage,
    waf: wafImage,
    siem: siemImage,
    ubuntu: pcImage,
    mikrotik: mikrotikImage,
    testagent: testagentImage,
    cli_a_lx: clialxImage,
    mgt_a: mgtaImage,
    mgt_a_intro: mgtaIntroImage,
    astralinux: astraLinuxImage,
    redos: redosImage,
    kalilinux: kaliLinuxImage,
    activedirectory: adImage,
    tech_tour_ad: techTourAdImage,
    wec: wecImage,
    logan: loganImage,
    pppoeserver: pppoeImage,
    windows: windowsImage,
    encryptor: encryptorImage,
    ftp: ftpImage,
    telemetryservice: telemetryImage,
    smtp: smtpImage,
    icap: icapImage,
    radius: radiusImage,
    tacacs: tacacsImage,
    webserver: webServerImage,
    www: wwwImage,
    www1: wwwImage1,
    www2: wwwImage2,
    isp_intro: ispIntroImage,
    isp1: ispImage1,
    isp2: ispImage2,
    vulnerableapp: vulnerableappImage,
    internet: internetImage,
    cisco: ciscoImage,
    collector: collectorImage,
    ptngfw: ptngfwImage,
    ptmgmt: ptmgmtImage,
};

export const CROPPED_NODES_NAMES: Record<string, string> = {
    ACTIVEDIRECTORY: 'AD',
} as const;

export const SPECIAL_NODE_TYPES = {
    MC: 'mc',
    ACTIVE_DIRECTORY: 'activedirectory',
    ICAP: 'icap',
    TREX: 'trex',
};

export const ERROR_STATUS_WITH_IPS = 'Terraform deploy';
export const DEFAULT_SHOULD_REGISTER_NODE = true;
export const DEFAULT_SHOULD_ACTIVATE_LICENSE = true;
export const DEFAULT_SHOULD_ENABLE_ROOT_ACCESS = false;
